<nav class="navbar navbar-light sub-nav">
  <div class="nav-left-items">
    <div class="dropdown">
      <button class="btn btn-dropdown dropdown-toggle" (click)="showErrorMessage = false" [disabled]="isLoading"
        type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{ sheetSelected }}
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <ul class="dropdown-item-ul" *ngFor="let item of availableSheets">
          <li>
            <button class="dropdown-item" (click)="selectSheet(item)">
              {{ item }}
            </button>
          </li>
        </ul>
      </div>
    </div>
    <button class="delete-button-1" (click)="onClickShowConfirmPopup('deletedata')"
      [disabled]="maxLimitReached||!enableDelete">
      {{constants.DELETE_TXT}}
    </button>
  </div>
  <span class="row count-display" *ngIf="showCount">
    <div class="col-4 count">
      {{uploadedVideosCount}}
    </div>
    <div class="col-8 count-txt">
      Windows Approved this session
    </div>
  </span>
  <span class="navbar-text justify-content-end">
    <input id="search" class="search" type="text" [(ngModel)]="filteredString" placeholder="Search"
      (ngModelChange)="Search()" (ngModelChange)="Search()" />
  </span>
</nav>

<div class="item-container container-fluid" *ngIf="isLoading">
  <div class="row">
    <div class="col-3 video-card" *ngFor="let item of skeltonArray">
      <div class="imageSkelton"></div>
      <div class="card-text-container">
        <div class="textSkelton"></div>
        <div class="textSkelton-1"></div>
        <div class="textSkelton"></div>
        <div class="textSkelton-1"></div>
      </div>
    </div>
  </div>
</div>

<div class="item-container container-fluid videoBox" *ngIf="!isLoading">
  <!-- <div class="confirm" *ngIf="displaySuccessMessageDiv">
    <button type="button" id="confirm" class="btn btn-dark">{{constants.YOUR_TXT}}</button>
  </div>
  <div class="confirm" *ngIf="showErrorMessage">
    <button type="button" id="error" class="btn btn-dark">{{constants.ERROR_TXT}}</button>
  </div>
  <div class="confirm" *ngIf="maxLimitReached">
    <button type="button" id="error" class="btn btn-dark">As per google api policy max 3 selections are available
    </button>
  </div> -->
  <div id="success-alert" class="alert alert-success alert-dismissible fade show" role="alert"
    *ngIf="displaySuccessMessageDiv">
    <strong id="videoTitle">{{videoDetails}}</strong> <span id="message"> {{successMessage}}</span>
    <button (click)="closeSuccessAlert()" type="button" class="close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div id="error-alert" class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="showErrorMessage">
    <span id="error-message">{{errorMessage}}</span>
    <button (click)="closeErrorAlert()" type="button" class="close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="row">
    <div class="col-3 video-card" *ngFor="let item of videoList | filter: filteredString" id="card{{item.rowIndex}}">
      <input [ngClass]="{
          'form-check-input': !showVideo,
          'form-check-input-1': showVideo
        }" (change)="enabledelete($event, item)" type="checkbox" id="checkboxNoLabel{{ item.rowIndex }}" value=""
        aria-label="..." />
      <label for="checkboxNoLabel{{ item.rowIndex }}" class="checkmark"></label>
      <img type="button" src="{{ item.thumbnail }}" alt="" (click)="openVideo(item)"
        onerror="this.onerror=null; this.src='https://d2asw23jcw8al0.cloudfront.net/public/403.png'" />
      <div class="card-text-container" (click)="openVideo(item)">
        <p class="card-text">{{ item.city }}</p>
        <p class="card-text">{{ item.country }}</p>
        <p class="card-text">{{ item.author }}</p>
        <p class="card-text-error">{{ item.error }}</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showVideo" class="custom-modal-background">
  <form [formGroup]="uploadSubmit">
    <div class="modal-content-bacground">
      <button (click)="onClose()" class="close">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#265D6E" class="bi bi-x"
          viewBox="0 0 16 16">
          <path
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </button>
      <iframe class="video-player" [src]="selectedUrl | safe" allow="autoplay"></iframe>
      <div class="edit-container">
        <p *ngIf="!editTitle" class="view-title">
          {{ selectedAuthor }} - {{ selectedCity }}, {{ selectedCountry }}
        </p>
        <div *ngIf="editTitle" class="edit-title-container">
          <input [ngClass]="{
              'edit-input': !uploadSubmit.get('author').errors?.required,
              'edit-input-1': uploadSubmit.get('author').errors?.required
            }" type="text" formControlName="author" autofocus="autofocus" value="{{ selectedAuthor }}"
            [readonly]="savingEditedData" />
          <input [ngClass]="{
              'edit-input': !uploadSubmit.get('city').errors?.required,
              'edit-input-1': uploadSubmit.get('city').errors?.required
            }" type="text" formControlName="city" value="{{ selectedCity }}" [readonly]="savingEditedData" />
          <input [ngClass]="{
              'edit-input': !uploadSubmit.get('country').errors?.required,
              'edit-input-1': uploadSubmit.get('country').errors?.required
            }" type="text" formControlName="country" value="{{ selectedCountry }}" [readonly]="savingEditedData" />
        </div>
        <button *ngIf="!editTitle" (click)="onClickEditTitle()" class="view-edit">
          {{constants.EDIT_DETAILS_TXT}}
        </button>
        <div *ngIf="editTitle" class="save-container">
          <button (click)="onClickDoneEdit()"
            [disabled]="uploadSubmit.get('author').errors?.required || uploadSubmit.get('city').errors?.required || uploadSubmit.get('country').errors?.required || savingEditedData"
            class="view-edit-save">{{constants.SAVE_TXT}}</button>
          <button (click)="cancelClick()" class="view-edit">{{constants.CANCEL}}</button>
        </div>
      </div>
      <p class="view-message">{{ selectedMessage }}</p>
      <div class="email-conainer">
        <a class="view-email">{{ selectedEmail }}</a>
        <!-- <p class="duration-date">duraion</p> -->
        <p class="duration-date">{{ seletecDateUploaded }}</p>
      </div>
      <div class="tag-container">
        <div class="tag-button" *ngFor="let item of tags">
          <input [disabled]="!editTitle || savingEditedData" class="tag-input" [checked]="item.status"
            (change)="tagChange($event, item)" type="checkbox" id="{{ item.name }}" name="{{ item.name }}"
            value="{{ item.status }}" />
          <label class="tag-label" for="{{ item.name }}">{{ item.name }}</label>
        </div>
      </div>
      <div *ngIf="uploadStatus !== null" class="upload-status">Upload Status: 
        <span>{{uploadStatus}}</span>
        <div class="spinner-border text-success" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="view-button">
        <button class="upload" [disabled]="uploadingToVimeo" (click)="uploadToVimeo()">{{constants.UPLOAD_TXT}}</button>
        <button class="delete" [disabled]="clickedDeleteButton || uploadingToVimeo"
          (click)="onClickShowConfirmPopup('deleteSingleVideo')">{{constants.DELETE_TXT}}</button>
      </div>
    </div>
  </form>
</div>

<!-- confirm modal -->

<div class="modal-popup" id="modal-popup-confirm" *ngIf="showconfirmModal">
  <div class="confirm-popup-content popup-content-confirm">
    <div class="popup-content-confirm-margin">
      <h1>Do you want to delete this video ?</h1>
    </div>
    <button [disabled]="isRemoving" type="button" class="yes-button" (click)="this[deleteType]()">
      <div *ngIf="isRemoving" class="spinner-border removing-spinner" role="status">
        <span class="sr-only">{{constants.LOADING_TEXT}}</span>
      </div>
      <div *ngIf="!isRemoving">{{constants.YES}}</div>
    </button>
    <button type="button" class="no-button" (click)=onClickCloseConfirmPopup()>
      {{constants.CANCEL}}
    </button>
  </div>
</div>